/**
 * Chart-specific color constants for empty states and UI elements
 * Used across all GenericChart components for consistent styling
 */

// Empty state colors
export const CHART_EMPTY_STATE_COLORS = {
  // Axis lines, ticks, and grid lines in empty state
  AXIS_LINE: '#E5E7EB',
  AXIS_LINE_OPACITY: 0.3,

  // "No Data" text color
  NO_DATA_TEXT: '#9CA3AF',

  // Data zoom slider handle color
  DATA_ZOOM_HANDLE: '#C1CFD6',

  // Border colors
  BORDER_WHITE: '#ffffff',
  BORDER_TRANSPARENT: 'transparent',
} as const;

// Chart styling constants
export const CHART_STYLING = {
  // Font sizes
  NO_DATA_FONT_SIZE: 14,
  NO_DATA_FONT_WEIGHT: 'normal' as const,

  // Border widths
  BORDER_WIDTH: 1,
  BORDER_WIDTH_THICK: 2,

  // Opacity values
  FULL_OPACITY: 1,
} as const;
